import { NameID } from "common/types/NameID";

// 来園者一覧（来園場所一覧、来園方法一覧、特記利用種別一覧）
export type VisitorData = {
  id: number;
  name: string;

  // 時間帯ごとのカウント
  counts: VisitorCount[];

  // 合計利用者数
  total: number;

  inactive?: boolean;
};

export type VisitorCount = {
  period: NameID;
  count: number;
};

// 重複利用の番号 (合計しないために使用)
export const PERIOD_DUPLICATE = 2;
